import React, { useEffect, useState } from 'react';
import './CreateTasks.css';

function CreateTasks() {
  const [jobDate, setJobDate] = useState('');
  const [numTasks, setNumTasks] = useState(20);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [counts, setCounts] = useState({ activeLeadsWithJobs: 0, scoredJobs: 0 });

  // Fetch counts whenever date changes
  useEffect(() => {
    const fetchCounts = async () => {
      if (!jobDate) return;
      try {
        const resp = await fetch(`/api/tasks/counts-for-date/?date=${encodeURIComponent(jobDate)}`);
        if (!resp.ok) {
          const t = await resp.text();
          throw new Error(t || 'Failed to fetch counts');
        }
        const data = await resp.json();
        setCounts({
          activeLeadsWithJobs: data.activeLeadsWithJobs || 0,
          scoredJobs: data.scoredJobs || 0,
        });
      } catch (err) {
        setCounts({ activeLeadsWithJobs: 0, scoredJobs: 0 });
      }
    };
    fetchCounts();
  }, [jobDate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess('');
    setError('');
    try {
      const resp = await fetch('/api/tasks/create-for-date/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ jobDate, numTasks }),
      });
      const data = await resp.json();
      if (!resp.ok) throw new Error(data.error || data.message || 'Failed to create tasks');
      setSuccess(`Created ${data.created} tasks. Skipped existing: ${data.skippedExisting}. Unmapped: ${data.skippedUnmapped}.`);
    } catch (err) {
      setError(String(err.message || err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content">
      <h1 className="main-title">Bulk Create Tasks for Active Leads</h1>
      <form className="tasks-form" onSubmit={handleSubmit}>
        <div className="form-section">
          <label className="form-label">1. Select Job Date (and Due Date)</label>
          <div className="form-desc">Tasks will be created for all active leads. Due date will be the same as the job date.</div>
          <input
            type="date"
            className="form-input"
            value={jobDate}
            onChange={e => setJobDate(e.target.value)}
            required
          />
          {jobDate && (
            <div className="form-desc" style={{ marginTop: 8 }}>
              For {jobDate}: Active leads with scored jobs: <b>{counts.activeLeadsWithJobs}</b>, total scored jobs: <b>{counts.scoredJobs}</b>
            </div>
          )}
        </div>
        <div className="form-section">
          <label className="form-label">2. Number of Tasks per Lead (cap)</label>
          <div className="form-desc">Specify the maximum number of tasks to create for each active lead, based on their top scored jobs. Defaults to 20.</div>
          <input
            type="number"
            className="form-input"
            min={1}
            max={20}
            value={numTasks}
            onChange={e => setNumTasks(e.target.value)}
          />
        </div>
        <div className="form-section">
          <label className="form-label">3. Create Tasks</label>
          <button
            type="submit"
            className="submit-btn"
            disabled={loading}
          >
            {loading ? 'Creating...' : 'Create Tasks for Active Leads'}
          </button>
          {success && <div className="success-msg">{success}</div>}
          {error && <div className="error-msg">{error}</div>}
        </div>
      </form>
    </div>
  );
}

export default CreateTasks;
